import { AssembledBOMList } from './AssembledBOMList';

export default AssembledBOMList;
